/**
 * ErrorBoundary is the place to clarify react errors in development
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SVBErrorPage } from '@svb/portal-ui-react-components';
import icon from '@svb/svbbranding/dist/assets/icons/icon-error.svg';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 *
 */

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }
  /* istanbul ignore next */
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ hasError: false });
    }
  }
  /* istanbul ignore next */
  onclickHandle = () => {
    this.props.navigate('/', { replace: true });
    this.setState({ hasError: false });
  };
  render() {
    if (this.state.hasError) {
      return (
        <SVBErrorPage
          title={'Something went wrong!'}
          subTitle={'It happens sometimes, you may refresh the page or go to home.'}
          icon={icon}
          buttonText={'Go Home'}
          handleButtonClick={() => this.onclickHandle()}
        />
      );
    }

    return this.props.children;
  }
}
const ErrorBoundaryWithNavigation = (ErrorBoundaryComp) => {
  const ErrorBoundaryCompWithNavigateHook = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    return <ErrorBoundaryComp {...props} navigate={navigate} location={location} />;
  };
  return ErrorBoundaryCompWithNavigateHook;
};

export default ErrorBoundaryWithNavigation(ErrorBoundary);

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};
